import { Injectable, signal } from '@angular/core';

/** Po tylu milisekundach oczekiwania pokazujemy globalny wskaźnik ładowania. */
const SHOW_AFTER_MS = 4000;

/**
 * Globalny wskaźnik ładowania: liczy żądania w locie i po czterech sekundach
 * zapala sygnał. Wcześniej ten licznik siedział w `HttpService`, przez co widział
 * tylko żądania wysłane właśnie stamtąd.
 */
@Injectable({ providedIn: 'root' })
export class LoadingIndicatorService {
  private readonly _isLoading = signal(false);
  private inFlight = 0;
  private timer: ReturnType<typeof setTimeout> | undefined;

  readonly isLoading = this._isLoading.asReadonly();

  start(): void {
    this.inFlight += 1;

    if (!this.timer) {
      this.timer = setTimeout(() => this._isLoading.set(true), SHOW_AFTER_MS);
    }
  }

  stop(): void {
    this.inFlight = Math.max(0, this.inFlight - 1);

    if (this.inFlight > 0) {
      return;
    }

    if (this.timer) {
      clearTimeout(this.timer);
      this.timer = undefined;
    }

    this._isLoading.set(false);
  }
}
